export const getCustomerToken = (slug) => localStorage.getItem(`zylo_customer_${slug}`);

export const setCustomerSession = (slug, token, customer) => {
  localStorage.setItem(`zylo_customer_${slug}`, token);
  localStorage.setItem(`zylo_customer_${slug}_info`, JSON.stringify(customer));
};

export const getCustomerInfo = (slug) => {
  try { return JSON.parse(localStorage.getItem(`zylo_customer_${slug}_info`)); } catch { return null; }
};

export const clearCustomerSession = (slug) => {
  localStorage.removeItem(`zylo_customer_${slug}`);
  localStorage.removeItem(`zylo_customer_${slug}_info`);
};
